import { ArrowDropDown } from '@components/std-components/resources'
import { IIcon } from '@components/std-components/TopBar'
import SATopbar from '@modules/showroom/SATopbar'
import { runInAction } from 'mobx'
import { useObserver } from 'mobx-react-lite'
import React, { FC, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import Button from '@components/std-components/Button'
import { Search } from '@components/std-components/Search'
import { CentricTypography } from '@core/component/CentricTypography'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import BackToOrders from '@modules/order/components/SAOrderTopbar/components/BackToOrders'
import { isRegionalMerchandiserRole } from '@services/commonServices'
import { storage } from '@services/storageService'
import { User } from '@models'
import { CardSizeSelectorPopup, getConfig } from '@modules/showroom/CardSizeSelectorPopup'
import { UserPreference } from '@stores/userPreferencesStore'
import omit from 'lodash/omit'
import find from 'lodash/find'
import { ProductCardSizes } from '@constants'

import map from 'lodash/map'
import indexOf from 'lodash/indexOf'
import without from 'lodash/without'
import { KPITableView } from '@modules/order/stores/view/KPI/KPIViewTableService'
import { QuantityType } from '@components/UI-Components/QuantityType/constants/QuantityType'
import { useTranslation } from 'react-i18next'
import { withIconHOC } from '@components/std-components/Icons'
import { ListUIStore } from '@modules/order/stores/view/List/ListUIStore'
import { QUANTITY_TYPE_OPTIONS } from '@components/UI-Components/QuantityType/constants/QuantityType'
import { config } from '@config'
import Link from '@material-ui/core/Link'
import { getEnumValue } from '@utils/get-enum-value'
import { EnhancedViewIconMapping, View } from '@modules/order/constants/views'
import OrderContext from '@modules/order/contexts/order-context'
import ViewContext from '@modules/order/contexts/view-context'
import { rightIcons } from '@modules/order/components/SAOrderTopbar/utils/TopBarElements'
import { OrderNavigation } from '@modules/order/components/SAOrderTopbar/components/OrderNavigation'
import { Grid, Tooltip, makeStyles } from '@material-ui/core'
import { CNFProductFilterPopup } from '@modules/showroom/CNFProductFilter/container/CNFProductFilterPopup'
import { EnhancedSortByPopup } from '@components/UI-Components/EnhancedView/Sort/EnhancedSortByPopup'
import { GroupByPopup } from '@components/UI-Components/EnhancedView/GroupByPopup'
import { stores } from '@stores'
import ReplyIcon from '@material-ui/icons/Reply'
import { SIDEBAR_CONFIG } from '@api/showroom/Sidebar/common'
import { HierarchyHideIcon, HierarchyShowIcon } from '@core'
import {
  AddPlusIcon,
  CommonClearIcon,
  OrderDetailsIcon,
  SelectAllNewIcon,
  SettingIcon,
  CreateNewViewIcon
} from '@components/UI-Components/svg'
import classNames from 'classnames'
import { ConfirmationDialog } from '@components/UI-Components/ConfirmationDialog'
import { orderKPIGlobalTopBarStore } from '@modules/order/stores/OrderKPIGlobalTopBarStore'
import EnhancedViewSelector from '../EnhancedViewSelector/EnhancedViewSelector'
import {
  getEnhancedKPITabs,
  getEnhancedViews
} from '../EnhancedViewSelector/EnhancedViewSelectorOptions'
import { ListTableView } from '@modules/order/stores/view/List/ListViewTableService'
import EnhancedQuantitySwitch from '../EnhancedQuantitySwitch/EnhancedQuantitySwitch'
import useOrderContext from '@modules/order/hooks/use-order-context'
import { EnhancedTableSettingsPopup } from '@modules/showroom/EnhancedTableSettings/EnhancedTableSettingsPopup'
import { enhancedTableSettingsContext } from '@modules/showroom/EnhancedTableSettings/context/enhancedTableSettings-context'
import EnhancedWarningDropdown from '../EnhancedWarningButton/EnhancedWarningDropdown'
import { ToggleSwitch } from '../ToggleSwitch/ToggleSwitch'

const useStyles = makeStyles(theme => ({
  container: {},
  closeButton: {
    borderRadius: 1,
    height: 36,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  orderName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 500,
    textAlign: 'justify',
    paddingBottom: 2,
    marginLeft: -8,
    '& h3': {
      overflow: 'inherit',
      textOverflow: 'inherit'
    }
  },
  addProductTitle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 500,
    marginLeft: 0,
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    '& h4': {
      overflow: 'inherit',
      textOverflow: 'inherit'
    },
    '& h3': {
      overflow: 'inherit',
      textOverflow: 'inherit'
    }
  },
  customElemImg: {
    cursor: 'pointer'
  },
  highLightCustomSettings: {
    backgroundColor: '#cccccc'
  }
}))

const getDivider = () => {
  return (
    <div
      style={{
        width: 1,
        height: 21,
        border: 'solid 1px rgba(0, 0, 0, 0.1)'
      }}
    ></div>
  )
}

interface OrderTopbarProps {
  baseUrlNavIconConfig?: IIcon
  tableStoreInstance?: any
  onSettingsChange?: (s) => {}
}

const EnhancedOrderTopbar: FC<OrderTopbarProps> = ({
  baseUrlNavIconConfig,
  tableStoreInstance,
  onSettingsChange
}) =>
  useObserver(function useHook() {
    const classes = useStyles()
    const {
      t,
      i18n: { language }
    } = useTranslation()
    const {
      nav: { queryParams, updateQueryParams },
      showroomSidebarStore: { redirectToPage },
      productConfiguration: {
        loadedConfigData,
        isWarningModeActive,
        initialAllocationActivated,
        initialAllocationEnabled,
        dataExploreViewEnabled
      }
    } = stores
    const { orderId, isAddProductToOrderView, subSection, clientType, orderType } =
      queryParams
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false)

    const {
      uiStore: {
        getOrderName,
        isOrderEditable,
        showOrdernavigation,
        isViewSelectorPopupOpen,
        setViewSelectorPopupState,
        view,
        setOrderDetailsModalState,
        setView,
        setPreviousSelectedData,
        previousSelectedData,
        dataStore: { isOrderNavigationOpen, summary, summaryLoaded },
        quantityTypeStore: { options, setType, type }
      }
    } = useContext(OrderContext)
    const { uiStore } = useContext<any>(ViewContext)

    const {
      isSidebarOpen,
      toggleSidebar,
      addAllProductToOrder,
      removeAllProductFromOrder,
      dataStore: {
        enhancedSortStore,
        cnfProductFilterStore,
        cnfGroupByUIStore,
        setInitialTotalProducts,
        searchKey,
        heirarchy
      },
      toggleIsSearchActive,
      isSearchActive,
      onSearchKeyChange,
      isFilterActive,
      toggleFilterModal,
      isCardSizeModalOpen,
      toggleCardSizeModal,
      hideShowSearch,
      setNewAppliedFilters,
      isEnhancedSortActive,
      toggleEnhancedSortModal,
      applyEnhancedSortByOptions,
      isGroupByActive,
      toggleGroupByModal,
      applyGroupByOptions,
      isKPISettingsOpen,
      setIsKPISettingsOpen,
      setOpenCustomViewSettingsPopup,
      applyEnhancedWarningFilters,
      handleInitialAllocationToggle
    } = uiStore

    const setViewOfKPI = uiStore?.tableStore?.setView
    const enhancedWarningPopupStore = uiStore.dataStore?.enhancedWarningPopupStore || {}
    const {
      warningDropdownFilters = [],
      appliedWarningFilterOption,
      isEnhancedWarningActive,
      setAppliedWarningFilterOption = () => {},
      toggleEnhancedWarningModal = t => {},
      warningFiltersLoading = false
    } = enhancedWarningPopupStore

    const { isValueSelected, setIsValueSelected } = uiStore as ListUIStore
    const { totalProducts = 0 } =
      orderKPIGlobalTopBarStore.enhancedOrderKPIsForGlobalTopBar
    const isRetailView = clientType === getEnumValue(VIPClientType.Internal)

    const isQuantityView = isRetailView
      ? subSection === ListTableView.Quantity
      : view === View.List

    const tableSettingsStore = useContext(enhancedTableSettingsContext)
    const {
      uiStore: { isTableSettingActive, toggleTableSettingModal }
    } = tableSettingsStore

    const {
      order: { url: orderURL }
    } = SIDEBAR_CONFIG

    const user = storage.getItem<User>('user')

    const filterBadgeCount = cnfProductFilterStore?.totalFilterSelectionCount

    const resetFilterSearch = useCallback(() => {
      cnfProductFilterStore?.resetFilterSearch()
    }, [cnfProductFilterStore])

    const orderContext = useOrderContext()
    const updatedTableSetting = orderContext?.uiStore?.dataStore?.updatedTableSetting

    const handleApplyClick = updatedSettings => {
      const key =
        view === View.List
          ? isQuantityView
            ? ListTableView.Quantity
            : ListTableView.Summary
          : subSection

      updatedTableSetting({
        [key]: {
          ...updatedSettings
        }
      })
    }
    const settingsElem = useMemo(() => {
      return tableStoreInstance
        ? {
            name: 'tableSettings',
            showIcon: view === View.List,
            isCustomElement: true,
            customElement: EnhancedTableSettingsPopup,
            customElementProps: {
              popupProps: {
                open: isTableSettingActive,
                onOpen: () => toggleTableSettingModal(true),
                onClose: () => toggleTableSettingModal(false)
              },
              settingProps: {
                tableStoreInstance: tableStoreInstance,
                handleApplyClick: updatedSettings => handleApplyClick(updatedSettings)
              }
            },
            disable: !heirarchy?.length
          }
        : {}
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      isTableSettingActive,
      toggleTableSettingModal,
      tableStoreInstance,
      tableStoreInstance?.settings,
      t,
      view,
      subSection,
      heirarchy
    ])

    useEffect(() => {
      if (loadedConfigData) {
        if (!isWarningModeActive) {
          runInAction(() => {
            uiStore?.init()
          })
        }
        if (isWarningModeActive && !warningFiltersLoading) {
          runInAction(() => {
            uiStore?.init()
          })
        }
      }
      return () => {
        uiStore?.destroy()
      }
    }, [uiStore, loadedConfigData, orderId, view, subSection, warningFiltersLoading, isWarningModeActive, initialAllocationActivated])
    const filteredOptions =
      subSection === KPITableView.DoorsKPI
        ? without(options || [], QuantityType.Product)
        : options

    const getViewName = useMemo(() => {
      const listItems = getEnhancedViews(clientType, orderType)
      const viewItems = listItems.filter(elem => elem.id === view)
      let itemFound = null
      let dropDownText = ''
      if (viewItems?.length) {
        if (subSection) {
          itemFound = viewItems.find(elem => elem.subSection === subSection)
          if (!itemFound && viewItems.length === 1) {
            itemFound = viewItems[0]
          }
        } else {
          itemFound = viewItems[0]
        }
      }
      if (itemFound) {
        dropDownText = t(itemFound?.name?.key, itemFound?.name?.default)
      }
      return dropDownText
    }, [clientType, view, subSection, t, orderType])

    const mainRightIcons = useMemo(
      () => {
        const selectedQtyType = find(QUANTITY_TYPE_OPTIONS, option => option.id === type)
        return rightIcons(
          {
            clientType,
            quantityTypeProps: {
              options: map(filteredOptions, option => {
                const type = find(QUANTITY_TYPE_OPTIONS, type => type.id === option)
                return t(`quantityTypes.${type.key}`, type.name)
              }),
              setType: (selectedType: string) => {
                const newType =
                  filteredOptions[
                    indexOf(
                      map(filteredOptions, option => {
                        const type = find(
                          QUANTITY_TYPE_OPTIONS,
                          type => type.id === option
                        )
                        return t(`quantityTypes.${type.key}`, type.name)
                      }),
                      selectedType
                    )
                  ]
                setType(newType)
                // set qty/value switch to qty if 'product quantity' is selected
                if (isValueSelected && QuantityType.Product === newType)
                  setIsValueSelected(null, false)
              },
              type:
                selectedQtyType &&
                t(`quantityTypes.${selectedQtyType.key}`, selectedQtyType.name)
            }
          },
          true
        )
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [clientType, language, filteredOptions, type, isValueSelected]
    )

    const orderNav = useMemo(() => {
      return {
        name: 'orderNav',
        text: `${getOrderName}`,
        image: ArrowDropDown,
        showIconRight: true,
        showIcon: view !== View.AddProduct,
        isPopUp: true,
        popUpContent: <OrderNavigation />,
        popUpProps: {
          position: 'bottom left',
          className: 'pop-up-custom',
          open: isOrderNavigationOpen,
          onOpen: () => showOrdernavigation(true),
          onClose: () => showOrdernavigation(false)
        },
        typographyDetails: {
          variant: 'h3',
          class: classes.orderName,
          showTooltip: true
        }
      }
    }, [getOrderName, isOrderNavigationOpen, showOrdernavigation, view, classes])

    const subLeftIcons = useMemo(
      () => [
        baseUrlNavIconConfig
          ? baseUrlNavIconConfig
          : {
              name: 'navBack',
              isCustomElement: true,
              customElement: BackToOrders,
              showIcon: view !== View.AddProduct
            },
        {
          name: 'addProductsToOrderTitle',
          isCustomElement: true,
          customElement: () => {
            return (
              <Grid container className={classes.addProductTitle}>
                <CentricTypography variant='h3'>
                  {t('order.addProducts', 'Add Products')}
                </CentricTypography>
                &nbsp;
                <CentricTypography variant='h4'>
                  {`(Total ${totalProducts})`}
                </CentricTypography>
              </Grid>
            )
          },
          showIcon: view === View.AddProduct
        },
        orderNav
      ],
      [orderNav, view, t, classes, totalProducts]
    )

    const subRightIcons = useMemo(
      () => [
        {
          name: 'backToOldView',
          isCustomElement: true,
          customElement: () => (
            <Grid
              container
              onClick={() => {
                let url = orderURL
                let subView = subSection
                if (baseUrlNavIconConfig?.basePath) {
                  url = baseUrlNavIconConfig?.basePath + '/order'
                }
                if (dataExploreViewEnabled && view === View.KPI) {
                  const tabs = getEnhancedKPITabs(clientType, orderType, [])
                  subView = tabs?.find(item => item.id === subSection)?.id ?? tabs[0].id
                }
                redirectToPage(url, {
                  ...queryParams,
                  subSection: subView
                })
              }}
            >
              <Tooltip title={t('common.label.switchToOldView', 'Switch to old view')}>
                <ReplyIcon />
              </Tooltip>
            </Grid>
          ),
          showIcon: view === View.Product || View.List,
          disable: initialAllocationActivated
        },
        {
          name: 'deselectAllProducts',
          isCustomElement: true,
          showIcon: view === View.AddProduct,
          customElement: () => (
            <Grid
              className={classes.customElemImg}
              container
              onClick={() => {
                setShowConfirmationPopup(true)
              }}
            >
              <Tooltip title={t('common.label.deselectAll', 'Deselect All')}>
                <img src={CommonClearIcon} alt='Deselect all' />
              </Tooltip>
            </Grid>
          )
        },
        {
          name: 'selectAllProducts',
          showIcon: view === View.AddProduct,
          isCustomElement: true,
          customElement: () => (
            <Grid
              className={classes.customElemImg}
              container
              onClick={() => {
                addAllProductToOrder(
                  summary.doorOrder
                    ? [summary.doorOrder.doorOrderId]
                    : map(summary.doorOrders, 'id')
                )
              }}
            >
              <Tooltip title={t('common.label.selectAll', 'Select All')}>
                <img src={SelectAllNewIcon} alt='Select all' />
              </Tooltip>
            </Grid>
          )
        },
        {
          name: 'intialAllocationToggle',
          showIcon: initialAllocationEnabled,
          isCustomElement: true,
          customElement: ToggleSwitch,
          customElementProps: {
            label: (
              <CentricTypography variant='caption'>
                {t('common.label.initialAllocation', 'Initial Allocation')}
              </CentricTypography>
            ),
            isChecked: initialAllocationActivated,
            handleChange: e => {
              handleInitialAllocationToggle(e.target.checked)
            },
            disabled: false
          }
        },
        {
          name: 'warningProductBtn',
          showIcon: isWarningModeActive && warningDropdownFilters.length && summaryLoaded,
          isCustomElement: true,
          customElement: EnhancedWarningDropdown,
          customElementProps: {
            popupProps: {
              position: 'bottom center',
              open: isEnhancedWarningActive,
              onOpen: () => toggleEnhancedWarningModal(true),
              onClose: () => toggleEnhancedWarningModal(false)
            },
            warningProps: {
              warningOptions: warningDropdownFilters,
              setAppliedWarningFilterOption: val => {
                setAppliedWarningFilterOption(val)
                applyEnhancedWarningFilters()
              },
              appliedWarningFilterOption: appliedWarningFilterOption
            }
          }
        },
        {
          name: 'viewSelector',
          text: getViewName,
          icon: { element: EnhancedViewIconMapping[view], props: { size: 24 } },
          rightIconImage: ArrowDropDown,
          showIconRight: true,
          showIcon: view !== View.AddProduct,
          isPopUp: true,
          popUpContent: (
            <EnhancedViewSelector
              setView={(param1, param2) => {
                setView(param1, param2)
                if (view === View.KPI) {
                  setViewOfKPI?.(param2)
                }
              }}
              setViewSelectorPopupState={setViewSelectorPopupState}
            />
          ),
          popUpContentStyle: {
            width: '18%'
          },
          popUpProps: {
            position: 'bottom left',
            open: isViewSelectorPopupOpen,
            onOpen: () => setViewSelectorPopupState(true),
            onClose: () => setViewSelectorPopupState(false)
          },
          typographyDetails: {
            variant: 'captionDarkGrey'
          },
          tooltip: t('bb.settings.productCardConfigSettings.selectView', 'Select View')
        },
        {
          name: 'Create New View',
          showIcon: view === View.KPI && isKPISettingsOpen && dataExploreViewEnabled,
          icon: { element: withIconHOC({ imageSrc: CreateNewViewIcon }) },
          onItemClick: () => {
            setOpenCustomViewSettingsPopup?.(true)
          },
          tooltip: t(
            'bb.settings.productCardConfigSettings.tabs.createNewView',
            'Create New View'
          )
        },
        {
          name: 'customViewSetting',
          showIcon: view === View.KPI,
          icon: { element: withIconHOC({ imageSrc: SettingIcon }) },
          onItemClick: () => {
            setIsKPISettingsOpen?.(!isKPISettingsOpen)
          },
          customClass: isKPISettingsOpen ? classes.highLightCustomSettings : '',
          tooltip: t('bb.settings.productCardConfigSettings.tabs.settings', 'Settings')
        },
        {
          name: 'switch qty',
          showIcon:
            view === View.List &&
            (clientType === getEnumValue(VIPClientType.Internal)
              ? !subSection || subSection === ListTableView.Quantity
              : true),
          isCustomElement: true,
          disable: initialAllocationActivated,
          customElement: EnhancedQuantitySwitch,
          customElementProps: {
            checked: isValueSelected,
            onChange: setIsValueSelected,
            disabled: QuantityType.Product === type
          }
        },
        {
          name: 'divider1',
          isCustomElement: true,
          customElement: getDivider,
          showIcon: true
        },
        {
          name: 'addProducts',
          showIcon: view !== View.AddProduct,
          icon: { element: withIconHOC({ imageSrc: AddPlusIcon }) },
          disable: !isOrderEditable || initialAllocationActivated,
          onItemClick: () => {
            setPreviousSelectedData({ appliedFilters: {}, searchKey: '' })
            setView(View.AddProduct)
            hideShowSearch(false)
          },
          tooltip: t(
            'bb.settings.productCardConfigSettings.tabs.addProductToOrder',
            'Add Products to Order'
          )
        },
        {
          name: 'groupBy',
          showIcon: view !== View.KPI,
          isCustomElement: true,
          customElement: GroupByPopup,
          customElementProps: {
            popupProps: {
              position: 'bottom right',
              open: isGroupByActive,
              onOpen: () => toggleGroupByModal(true),
              onClose: () => toggleGroupByModal(false)
            },
            groupByProps: {
              applyGroupByOptions: applyGroupByOptions,
              cnfGroupByUIStore: cnfGroupByUIStore
            }
          }
        },
        {
          name: 'toggleHierarchy',
          isCustomElement: true,
          showIcon: view !== View.KPI,
          customElement: () => (
            <Grid
              container
              onClick={() => {
                toggleSidebar()
              }}
            >
              <Tooltip
                title={
                  isSidebarOpen
                    ? t('showroom.hideHierarchy.label', 'Hide Hierarchy')
                    : t('showroom.showHierarchy.label', 'Show Hierarchy')
                }
              >
                <Grid container>
                  {isSidebarOpen ? <HierarchyHideIcon /> : <HierarchyShowIcon />}
                </Grid>
              </Tooltip>
            </Grid>
          )
        },
        {
          name: 'divider2',
          isCustomElement: true,
          customElement: getDivider,
          showIcon: view !== View.KPI
        },
        {
          name: 'sortBy',
          showIcon: view !== View.KPI,
          isCustomElement: true,
          customElement: EnhancedSortByPopup,
          customElementProps: {
            popupProps: {
              position: 'bottom right',
              open: isEnhancedSortActive,
              onOpen: () => toggleEnhancedSortModal(true),
              onClose: () => toggleEnhancedSortModal(false)
            },
            sortByProps: {
              applySortByOptions: applyEnhancedSortByOptions,
              enhancedSortStore: enhancedSortStore
            }
          }
        },
        {
          name: 'filter',
          showIcon: view !== View.KPI,
          isCustomElement: true,
          customElement: CNFProductFilterPopup,
          customElementProps: {
            popupProps: {
              position: 'bottom right',
              open: isFilterActive,
              onOpen: () => toggleFilterModal(true),
              onClose: () => {
                toggleFilterModal(false)
                resetFilterSearch()
              },
              badgeCount: filterBadgeCount
            },
            filterProps: {
              onApply: setNewAppliedFilters,
              filterStore: cnfProductFilterStore
            }
          }
        },
        {
          name: 'search',
          isCustomElement: true,
          customElement: Search,
          showIcon: view !== View.KPI,
          customElementProps: {
            onSearchToggle: toggleIsSearchActive,
            showSearchInput: isSearchActive,
            enhancedViewEnabled: true,
            placeholder: t('common.label.search', 'Search'),
            onChange: e => onSearchKeyChange(e.target.value),
            style: {
              width: 250
            },
            value: searchKey
          }
        },
        {
          name: 'productRequest',
          showIcon:
            clientType === getEnumValue(VIPClientType.Internal) &&
            isRegionalMerchandiserRole(user) &&
            view === View.AddProduct &&
            !!config.productRequestUrl,
          isCustomElement: true,
          customElement: () => (
            <Link href={config.productRequestUrl}>
              <CentricTypography variant={'captionDarkGrey'}>
                {t('common.label.productRequest', 'Product Request')}
              </CentricTypography>
            </Link>
          )
        },
        {
          name: 'divider3',
          isCustomElement: true,
          customElement: getDivider,
          showIcon: true
        },
        {
          name: 'cardSize',
          showIcon: view === View.AddProduct || view === View.Product,
          isCustomElement: true,
          customElement: CardSizeSelectorPopup,
          customElementProps: {
            popupProps: {
              position: 'bottom right',
              open: isCardSizeModalOpen,
              onOpen: () => toggleCardSizeModal(true),
              onClose: () => toggleCardSizeModal(false)
            },
            actionProps: {
              config: getConfig(
                UserPreference.PRODUCT_CARD_PREFERENCE,
                omit(ProductCardSizes, ['ExtraSmall', 'Landscape']),
                t
              ),
              onApply: () => toggleCardSizeModal(false),
              onCancel: () => toggleCardSizeModal(false),
              isEnhancedViewEnabled: true
            }
          }
        },
        {
          name: 'doneAddProducts',
          isCustomElement: true,
          customElement: () => (
            <div
              onClick={() => {
                setInitialTotalProducts?.(0)
                if (isAddProductToOrderView) {
                  updateQueryParams({ isAddProductToOrderView: undefined })
                }
                setView(
                  previousSelectedData['view'] ?? View.Product,
                  previousSelectedData['subSection']
                )
              }}
            >
              <Button
                variant='primary'
                theme='custom'
                type='button'
                className={classes.closeButton}
                disabled={false}
              >
                <CentricTypography variant={'buttonWhite'}>
                  {t('common.label.done', 'Done')}
                </CentricTypography>
              </Button>
            </div>
          ),
          showIcon: view === View.AddProduct
        },
        {
          name: 'orderDetails',
          showIcon: view !== View.AddProduct,
          icon: { element: withIconHOC({ imageSrc: OrderDetailsIcon }) },
          onItemClick: () => setOrderDetailsModalState(true),
          tooltip: t('order.orderDetails', 'Order Details')
        },
        settingsElem
      ],
      [
        isSidebarOpen,
        toggleSidebar,
        isOrderEditable,
        view,
        user,
        clientType,
        orderType,
        isViewSelectorPopupOpen,
        setViewSelectorPopupState,
        isSearchActive,
        searchKey,
        toggleIsSearchActive,
        onSearchKeyChange,
        isFilterActive,
        toggleFilterModal,
        isCardSizeModalOpen,
        toggleCardSizeModal,
        setOrderDetailsModalState,
        setView,
        hideShowSearch,
        t,
        cnfProductFilterStore,
        filterBadgeCount,
        resetFilterSearch,
        setNewAppliedFilters,
        applyEnhancedSortByOptions,
        enhancedSortStore,
        isEnhancedSortActive,
        toggleEnhancedSortModal,
        applyGroupByOptions,
        cnfGroupByUIStore,
        isGroupByActive,
        toggleGroupByModal,
        queryParams,
        orderURL,
        redirectToPage,
        addAllProductToOrder,
        summary.doorOrder,
        summary.doorOrders,
        classes.closeButton,
        classes.customElemImg,
        isAddProductToOrderView,
        previousSelectedData,
        updateQueryParams,
        setInitialTotalProducts,
        getViewName,
        isValueSelected,
        setIsValueSelected,
        subSection,
        type,
        setPreviousSelectedData,
        setViewOfKPI,
        isEnhancedWarningActive,
        toggleEnhancedWarningModal,
        settingsElem,
        setIsKPISettingsOpen,
        isKPISettingsOpen,
        setOpenCustomViewSettingsPopup,
        classes.highLightCustomSettings,
        warningDropdownFilters,
        isWarningModeActive,
        applyEnhancedWarningFilters,
        appliedWarningFilterOption,
        setAppliedWarningFilterOption,
        summaryLoaded,
        handleInitialAllocationToggle,
        initialAllocationEnabled,
        initialAllocationActivated,
        dataExploreViewEnabled
      ]
    )
    return (
      <>
        <div
          className={classNames(classes.container, 'enhanced-topbar')}
          id='SAOrderTopbar'
        >
          <SATopbar
            mainRightIcons={mainRightIcons}
            subLeftIcons={subLeftIcons}
            subRightIcons={subRightIcons}
          />
        </div>
        {showConfirmationPopup && (
          <ConfirmationDialog
            open={showConfirmationPopup}
            title={t(
              'orderListTable.toolbar.deselectAllProducts.modal.header.label',
              'Note:'
            )}
            message={t(
              'order.deselectAllProducts.modal.message',
              'Removing these products will cause all associated quantities to be lost. Are you sure you want to proceed?'
            )}
            handleClose={() => {
              setShowConfirmationPopup(false)
            }}
            handleDelete={() => {
              removeAllProductFromOrder(
                summary.doorOrder
                  ? [summary.doorOrder.doorOrderId]
                  : map(summary.doorOrders, 'id')
              )
              setShowConfirmationPopup(false)
            }}
            proceedButtonTitle={t('common.label.confirm', 'Confirm').toUpperCase()}
            cancelButtonTitle={t('common.label.cancel', 'Cancel').toUpperCase()}
          />
        )}
      </>
    )
  })

export default EnhancedOrderTopbar
